<template>
  <div class="flex pb-1 pt-1 justify-center bg-gray-800" style='box-sizing: border-box'>
    <div class="flex-none flex justify-center">
      <pbc-button class="w-20" @click="$emit('edit')">
        <arrow-left class="h-8" :size='32' title="Back" />
        Back
      </pbc-button>
    </div>

    <div class="grow text-gray-400 text-sm font-thin self-center text-center">
      Enter a title for your post and press Save to post it!
    </div>
    <pbc-button @click='onPost' class="flex-none pbc-primary-color" :disabled='title === ""'>
      <span class="ml-2">Save</span>
      <chevron-right class="mr-2" />
    </pbc-button>
    <!--
    <pbc-button @click='showPostPopup = true' 
                class="md:grow self-end">
      <play class="h-8" :size='32' title="Play" />
      Post
    </pbc-button>
    -->

    <pbc-button v-if='isAdvancedMode && !paused' @click="$emit('playpause')">
      <pause class="h-8" :size='32' title="Pause" />
    </pbc-button>
    <pbc-button v-if='isAdvancedMode && paused' @click="$emit('playpause')">
      <play class="h-8" :size='32' title="Play" />
    </pbc-button>
    <pbc-button v-if='isAdvancedMode && paused' @click="$emit('step')">
      <step-forward class="h-8" :size='32' title="Step" />
    </pbc-button>

    <pbc-popup v-if='showPostPopup' @close='showPostPopup = false'>
      <div class="flex flex-col p-3">
        <h3 class="p-1 text-lg text-black font-semibold">Do you want to Post?</h3>
        <div class="p-2 py-4 flex flex-row justify-center">
          <pbc-button @click='showPostPopup = false'>
            <close />
            Cancel
          </pbc-button>
          <pbc-button @click='onPost'>
            <check />
            Post!
          </pbc-button>
        </div>
      </div>

    </pbc-popup>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import ChevronRight from '@icons/ChevronRight.vue';
import ArrowLeft from '@icons/ArrowLeft.vue';
import Pause from '@icons/Pause.vue';
import Play from '@icons/Play.vue';
import StepForward from '@icons/StepForward.vue';
import Check from '@icons/Check.vue';
import Close from '@icons/Close.vue';

export default {
  props: {
    paused: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default :''
    }

  },
  data() {
    return {
      showPostPopup: false
    }
  },
  components:{
    ArrowLeft,
    Pause,
    Play,
    Check,
    Close,
    ChevronRight,
    StepForward
  },
  methods: {
    onPost() {
      this.showPostPopup = false;
      this.$emit('post');
    }
  },
  computed: {
    ...mapState(['isAdvancedMode'])
  }
}
</script>
